import React, { Component } from 'react';
import ContentModel from '../../models/ContentModel';
import Office from '../../models/Office';

type OfficeViewProps = {
    office: Office,
    content: ContentModel
}

export default class OfficeView extends Component<OfficeViewProps, any> {
    public render() {
        const topSlope: number = Math.round(Math.random());
        return (
            <div className={"card mt-5 " + (topSlope ? " card-slope-top" : " card-slope-bottom")}>
                <div className="card-body">
                    <h6 className="card-title text-secondary mb-3">{this.props.office.name}</h6>
                    <p className="card-text text-medium mb-1">
                        {this.props.office.street} {this.props.office.houseNumber}<br />
                        {this.props.office.postalCode} {this.props.office.city}
                    </p>
                    <a className="text-medium text-underline" target="_blank" href={`https://maps.google.com/?daddr=${this.props.office.street}+${this.props.office.houseNumber},+${this.props.office.postalCode}+${this.props.office.city}`}>
                        {this.props.content.travelDirectionsLabel}
                    </a>
                    <hr className="background-dark-blue-25"></hr>
                    <p className="font-weight-bold mb-1">{this.props.content.openingsHoursLabel}</p>
                    <div className="text-medium" dangerouslySetInnerHTML={{ __html: this.props.office.openingHours }}>
                    </div>

                    <hr></hr>
                    <p className="font-weight-bold mb-1">{this.props.content.contactUsLabel}</p>
                    <ul>
                        <li>
                            <a href={"tel:" + this.props.office.telephone} className="text-medium text-underline">{this.props.office.telephone}</a>
                        </li>
                        <li>
                            <a href={"mailto:" + this.props.office.email} className="text-medium text-underline">{this.props.content.sendEmailLabel}</a>
                        </li>
                    </ul>
                </div>
            </div>
        );
    }
}